'use client'

import { useWalletClient } from 'wagmi'
import { getContract } from 'viem'
import STAKING_ABI from './stakingAbi.json'
import TOKEN_ABI from './tokenAbi.json'

const STAKING_CONTRACT = process.env.NEXT_PUBLIC_STAKING_CONTRACT as `0x${string}`
const TOKEN_CONTRACT = process.env.NEXT_PUBLIC_TOKEN_CONTRACT as `0x${string}`

export function useContracts() {
  const { data: walletClient } = useWalletClient();
  
  const stakingContract = walletClient
    ? getContract({
      address: STAKING_CONTRACT,
      abi: STAKING_ABI,
      client: walletClient,
    })
    : null

  const tokenContract = walletClient
    ? getContract({
      address: TOKEN_CONTRACT,
      abi: TOKEN_ABI,
      client: walletClient,
    })
    : null

  return { stakingContract, tokenContract }
}
